import { atom } from 'recoil';

export const searchViewTabIndexState = atom<number>({
  key: 'searchViewTabIndex',
  default: 0,
});
